import React from "react";

import {account$} from "../../../../../../emitters/account";
import MerchantDropdownAccount from "../../../helpers/MerchantDropdownAccount";
import formDropdownList from "./utils/formDropdownList";

export default () => {
  const account = account$.getValue() || {};
  const dropdownItems = formDropdownList(account);

  return (
    <MerchantDropdownAccount
      dropdownItems={dropdownItems}
      accountName={account.username}
    />
  )
}
